var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component, Fragment } from "react";
import authentication from "@irati/auth";
import teamService from "@irati/identity/services/teams";
import Button from "@irati/ui/src/Button";
import { H3 } from "@irati/ui/src/Headings";
import { Para } from "@irati/ui/src/Labels";
import { FormattedMessage } from "@irati/utils/lang";
import Flex from "@irati/ui/src/Flex";
import CreateTeamForm from "./CreateTeamForm";
var TeamList = /** @class */ (function (_super) {
    __extends(TeamList, _super);
    function TeamList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            teams: [],
            creatingNewTeam: false
        };
        _this.startCreateTeam = function () {
            _this.setState({ creatingNewTeam: true });
        };
        _this.handleHideCreateTeam = function () {
            _this.setState({ creatingNewTeam: false });
        };
        _this.handleDeleteTeam = function (team) {
            teamService.delete(authentication.business().uuid, team.uuid);
        };
        return _this;
    }
    TeamList.getDervivedStateFromProps = function (props, state) {
        props.setIsStepCompletable(!!state.teams.length);
        return {};
    };
    TeamList.prototype.componentDidMount = function () {
        var _this = this;
        this.teamSub = teamService.watchList(authentication.business().uuid).subscribe(function (data) {
            var teams = data.data.teams;
            _this.setState({ teams: teams.results });
        });
    };
    TeamList.prototype.componentWillUnmount = function () {
        if (this.teamSub) {
            this.teamSub.unsubscribe();
        }
    };
    TeamList.prototype.render = function () {
        var _this = this;
        var _a = this.state, teams = _a.teams, creatingNewTeam = _a.creatingNewTeam;
        if (creatingNewTeam) {
            return React.createElement(CreateTeamForm, { onSuccess: this.handleHideCreateTeam, onCancel: this.handleHideCreateTeam });
        }
        else {
            return (React.createElement(React.Fragment, null,
                React.createElement(Flex, { justifyContent: "space-between" },
                    React.createElement(H3, null,
                        React.createElement(FormattedMessage, { id: "setup_tenant.steps.teams.title" })),
                    React.createElement(Button, { primary: true, onClick: this.startCreateTeam },
                        React.createElement(FormattedMessage, { id: "setup_tenant.steps.teams.addTeam.text" }))),
                teams.map(function (team) { return (React.createElement(Fragment, { key: team.uuid },
                    React.createElement("hr", null),
                    React.createElement(Flex, { justifyContent: "space-between" },
                        React.createElement(Para, { large: true }, team.public_name),
                        React.createElement(Button, { onClick: function () { return _this.handleDeleteTeam(team); } },
                            React.createElement(FormattedMessage, { id: "setup_tenant.steps.teams.deleteTeam" }))))); })));
        }
    };
    return TeamList;
}(Component));
export default TeamList;
